const Reflux = require('@muzzylane/reflux');

const ServerRequest = require('./request');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');

const VoiceActions = Reflux.createActions({
    getVoices: { children: ["requested","completed","failed"] },
    setVoiceOptions: { children: ["completed","failed"] },
//    setVoiceElementMounted: { children: ["completed"] },
    setVoiceElementPlay: { children: ["completed"] },
//    setVoiceElementStartStop: { children: ["completed"] },
    adminGetChannelUsage: { children: ["requested","completed","failed"] },
    adminSetVoiceIdDisabled: { children: ["requested","completed","failed"] },
    adminSetVoiceIdCategories: { children: ["requested","completed","failed"] },
    
});

VoiceActions.getVoices.listen(function(actionId,options={}) {
    let {anonymous,polly,elevenlabs,cartesia} = options;
    if (!actionId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    this.requested(); // notify store that the data has been requested

    let middle = anonymous ? 'synthesize_audio_anon' : 'synthesize_audio';
    let args = '';
    let engineCount = 0;
    if (polly) {
        engineCount++;
    }
    if (elevenlabs) {
        engineCount++;
    }
    if (cartesia) {
        engineCount++;
    }
    if (engineCount > 1) {
        args='?s=all';
    }
    else if (elevenlabs) {
        args='?s=elevenlabs';
    }
    else if (polly) {
        args='?s=polly';
    }
    else if (cartesia) {
        args='?s=cartesia';
    }
    else {
        console.log("getVoices called without any systems specified"); // leave the arg blank and default to polly only
    }
//    let forceReload = true; // turn this off if our list of voices is stable
//    if (forceReload) {
//        if (args) {
//            args += '&reload=1';
//        }
//        else {
//            args += '?reload=1';
//        }
//    }
    
    ServerRequest.makeRequest(`/authoring/${middle}/all_voices${args}`, 'GET')
    .then(res => this.completed(actionId, res))
    .catch(err => this.failed(actionId, err));
});

VoiceActions.setVoiceOptions.listen(function(actionId, options) {
    if (!actionId || !options) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    this.completed(actionId, options);
});

//VoiceActions.setVoiceElementMounted.listen(function(mounted) {
//    this.completed(mounted);
//});

VoiceActions.setVoiceElementPlay.listen(function(actionId,play) {
    this.completed(actionId,play);
});

//VoiceActions.setVoiceElementStartStop.listen(function(actionId,objStartStop) { // {started:true} or {stopped:true}
//    this.completed(actionId,objStartStop);
//});


VoiceActions.adminGetChannelUsage.listen(function(actionId,channelId) {
    ServerRequest.makeRequest(`/authoring/channel_polly_usage/${channelId}`, 'GET')
    .then(res => this.completed(actionId, channelId, res))
    .catch(err => this.failed(actionId, channelId, err));
});

VoiceActions.adminSetVoiceIdDisabled.listen(function(actionId,options) {
    let { engine, Id, disable } = options;
    let args = `?engine=${encodeURIComponent(engine)}&id=${encodeURIComponent(Id)}&disable=${encodeURIComponent(disable)}`;
    ServerRequest.makeRequest(`/authoring/set_voice_disabled${args}`, 'PUT')
    .then(res => this.completed(actionId, res))
    .catch(err => this.failed(actionId, err));

});

VoiceActions.adminSetVoiceIdCategories.listen(function(actionId,options) {
    let { engine, Id, categories } = options;
    let args = {engine, voice_id:Id, categories};
    ServerRequest.makeRequest(`/authoring/set_voice_categories`, 'POST', JSON.stringify(args))
    .then(res => this.completed(actionId, res))
    .catch(err => this.failed(actionId, err));

});




module.exports = VoiceActions;